define.alias("shared/utils/formatters/ig-story-from-dynamo", "settings/utils/formatters/ig-story-from-dynamo");